$(document).ready(function($) {


    var field = $(".company_title_detail");
    var selectedItemValue;
    var langUrl = $("#lang-url").val();

    var options = {
        url: "/" + langUrl + "/companies/companies/get-companies-for-ajax",
        getValue: function (element) {
            return element.name;
        },
        list: {
            match: {
                enabled: true
            },
            onSelectItemEvent: function () {
                selectedItemValue = field.getSelectedItemData();
            },
            onHideListEvent: function () {
                //console.log(selectedItemValue);
            }
        },
        theme: "square"
    };

    field.easyAutocomplete(options);

    function addAutocomplate(obj) {
        var field = $(obj).find(".company_title_detail");
        var selectedItemValue;

        var options = {
            url: "/" + langUrl + "/companies/companies/get-companies-for-ajax",
            getValue: function (element) {
                return element.name;
            },
            list: {
                match: {
                    enabled: true
                },
                onSelectItemEvent: function () {
                    selectedItemValue = field.getSelectedItemData();
                },
                onHideListEvent: function () {
                    //console.log(selectedItemValue);
                }
            },
            theme: "square"
        };

        field.easyAutocomplete(options);

    }


    function validate(obj) {
        var _isValid = true;
        var fiealds = obj.find(".required-field");

        fiealds.each(function (i) {
            if(!$(this).val()){
                $(this).parent(".form-group").addClass("has-error");

                _isValid = false;

                // $('html, body').animate({
                //     scrollTop: $(this).offset().top
                // }, 100);
            }else{
                $(this).parent(".form-group").removeClass("has-error");
            }
        })

        return _isValid;
    }

    $("#dynamic-form").on("submit", function (e) {
        if (validate($(this)) == false)
            return false;
    });

    // $(".save-btn").on('click', function() {
    //     $(this).addClass("save-animation ");
    // });


    $(document).on("click", ".save-btn", function (e) {
        $(this).addClass("save-animation");
    });

});